import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { billingQKeys } from "@hooks/queries/billing/queryKeys";
import { followUpQKeys } from "@hooks/queries/followUp/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  billId: string;
  serviceId: string;
  consultationId: string;
  status: string;
}

export const useUpdateBillServiceStatus = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ billId, serviceId, status }: MutationProps) => {
      return api.patch(`billing/service/update/${billId}/${serviceId}`, {
        status,
      });
    },
    onSuccess: res => {
      // import.meta.env.DEV && console.log(res.data);
      queryClient.invalidateQueries({
        queryKey: billingQKeys.consultation(res.data.consultation_id),
      });
      queryClient.invalidateQueries({
        queryKey: followUpQKeys.all(),
      });
    },

    onError: (res: any, variables) => {
      console.error("[From Update Bill Service Status]", res);
      handleErrors(res, "mutation");

      queryClient.invalidateQueries({
        queryKey: billingQKeys.consultation(variables.consultationId),
      });
    },
  });
};
